import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import SystemDataService from '../../Services/SystemDataService';
import MediaComponent from '../../Utils/Media/media-component'; // Switched to MediaComponent
import { ButtonSecondary } from '../Buttons/button-component';
import { getQuickCallData } from '../../Public/quick-call-data';

const QuickCallSection = ({
    title: overrideTitle,
    subtitle: overrideSubtitle,
    paragraph: overrideParagraph,
    media: overrideMedia, // Renamed from image to media
    quickCallData: passedData
}) => {
    const systemData = useSelector(state => state.systemData || {});
    const { dir, language, links } = systemData;

    const defaultStrings = getQuickCallData(language);

    // Resolve Data Logic
    const title = overrideTitle || passedData?.title || defaultStrings.title;
    const subtitle = overrideSubtitle || passedData?.subtitle || defaultStrings.subtitle;
    const paragraph = overrideParagraph || passedData?.paragraph || defaultStrings.paragraph;
    const backgroundMedia = overrideMedia || passedData?.media || passedData?.image || defaultStrings.media || defaultStrings.image;
    const btnLabel = passedData?.btnText || defaultStrings.btnText;

    const Phone = SystemDataService.byLabel(links || [], 'Phone');

    /**
     * BH Hardware Title Split Logic:
     * First part White, second part Orange (secondary-500)
     */
    const renderStyledTitle = () => {
        if (!title) return null;
        const words = title.split(' ');
        const mid = Math.ceil(words.length / 2);
        const firstHalf = words.slice(0, mid).join(' ');
        const secondHalf = words.slice(mid).join(' ');

        return (
            <h2 className="text-4xl md:text-7xl font-bold uppercase  leading-[0.85] er">
                <span className="text-white">{firstHalf}</span>
                <span className="text-secondary-500 block md:inline md:ml-6">{secondHalf}</span>
            </h2>
        );
    };

    if (!title && !subtitle) return null;

    return (
        <section
            dir={dir}
            className="relative w-full min-h-[100vh] lg:min-h-[500px] flex flex-col justify-center items-center overflow-hidden bg-primary-950 border-y border-white/5"
        >
            {/* --- INDUSTRIAL MEDIA BACKGROUND --- */}
            <div className="absolute inset-0 z-0">
                {backgroundMedia ? (
                    <>
                        <MediaComponent
                            media={backgroundMedia}
                            className="w-full h-full object-cover opacity-30 grayscale hover:grayscale-0 transition-all duration-1000"
                            wrapperClassName="w-full h-full"
                            autoPlay={true}
                            loop={true}
                            muted={true}
                        />
                        {/* Blueprint Dot Grid Overlay */}
                        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:30px_30px] pointer-events-none" />

                        {/* Dramatic Industrial Gradient */}
                        <div className="absolute inset-0 bg-gradient-to-b from-primary-950 via-primary-950/50 to-primary-950/20 pointer-events-none" />
                    </>
                ) : (
                    <div className="absolute inset-0 bg-primary-950" />
                )}
            </div>

            {/* --- CONTENT LAYER --- */}
            <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col items-center text-center">

                {/* Big Industrial Title */}
                <div className="mb-12">
                    {renderStyledTitle()}
                </div>

                {subtitle && (
                    <h3 className="text-xl md:text-xl text-white/60 font-medium max-w-3xl italic leading-tight mb-14 drop-shadow-lg">
                        {subtitle}
                    </h3>
                )}

                {/* Direct Action Button */}
                <div className="flex flex-col items-center gap-10">
                    <div className='px-2 w-full '>
                        <ButtonSecondary
                            size="md"
                            href={Phone?.url}
                        >
                            {btnLabel}
                        </ButtonSecondary>
                    </div>

                    {/* {paragraph && (
                        <p className="max-w-2xl text-white/20 text-[10px] md:text-xs font-black uppercase tracking-[0.3em] leading-loose italic">
                            {paragraph}
                        </p>
                    )} */}
                </div>
            </div>

        </section>
    );
};

export default QuickCallSection;